import bg from '../assets/bg.png';
import chef from '../assets/chef.png';
import gallery01 from '../assets/gallery01.jpg';
import gallery02 from '../assets/gallery02.jpg';
import gallery03 from '../assets/gallery03.jpg';
import gallery04 from '../assets/gallery04.jpg';
import knife from '../assets/knife.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.png';
import findus from '../assets/findus.png';
import laurels from '../assets/laurels.jpg';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import cloud from '../assets/cloud.png';
import cloud9 from '../assets/cloud9.png';
import c_9 from '../assets/c_9.png';
import c9 from '../assets/c9.png';
import margarita from '../assets/margarita.png';


const exportedObject = {
  bg,
  chef,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  margarita,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  cloud,
  cloud9,
  c9,
  c_9,
};

export default exportedObject;
